import React from 'react';
import { Filter } from 'lucide-react';
export interface FilterButtonProps {
  /** Whether the filters are currently shown */
  isExpanded: boolean;
  /** Callback when button is clicked */
  onClick: () => void;
  /** Optional data-id for component identification */
  'data-id'?: string;
}
/**
 * FilterButton - Ocean Design System
 *
 * A ghost-style button for toggling filter visibility.
 * Follows Ocean specs: 40px height, 14px text, ocean primary hover.
 */
export function FilterButton({
  isExpanded,
  onClick,
  'data-id': dataId
}: FilterButtonProps) {
  return <button onClick={onClick} className="flex items-center gap-2 px-3 py-1.5 h-ocean-button text-ocean-small font-medium text-ocean-text-secondary hover:text-ocean-primary hover:bg-ocean-bg-secondary rounded-ocean-md transition-ocean-base" aria-expanded={isExpanded} aria-label="Toggle activity filters" data-id="element-4899" data-mp="qw26ubaftbnj">
      <Filter className="w-4 h-4" aria-hidden="true" data-id="element-4900" data-mp="1ndyiynt3aagh" />
      <span data-id="element-4901" data-mp="1nfj9818df78j">Filter</span>
    </button>;
}